module.exports = __webpack_public_path__ + "static/assets/3f5201aea12f282cdb6edd2575fef169.jpg";